import { defineStore } from 'pinia';
import { formModule } from '@/stores/form';

export const useSettingsSsoSetupForm = defineStore('settingsSsoSetupForm', () => formModule({
  fields: {
    entityId: { rules: [{ name: 'required' }], label: 'Entity ID' },
    samlUrl: { rules: [{ name: 'required' }, { name: 'url' }], label: 'SAML Location URL' },
    certificate: {
      rules: [
        { name: 'required' },
        {
          name: 'function',
          fn: (value) => value.trim().startsWith('MII'),
          errorMessage: 'The value should start with "MII"',
        },
      ],
      label: 'Certificate',
    },
  },
}));
